import React from "react";

export default function ProductWhyUseSection({
  title,
  description,
  useCases,
  highlight,
}: {
  title: string;
  description: string;
  highlight: string;
  useCases: { image: React.JSX.Element; title: string; description: string }[];
}) {
  const [before, after] = title.split(highlight);

  return (
    <section className="flex flex-col gap-4 justify-center items-center">
      <span className="md:text-[45px] text-2xl text-secondary-900 font-bold text-center">
        {before}{" "}
        <span className="bg-gradient-to-r from-[#4337cc] to-primary-900 bg-clip-text text-transparent">
          {highlight}
        </span>{" "}
        {after}
      </span>
      <span className="text-center w-full text-base md:text-xl md:w-2/3">
        {description}
      </span>
      <div className="px-8 py-20 rounded-lg bg-gradient-to-br from-[#FAFAFA] via-[#FAFAFA] to-[#E7D7FD] flex flex-col gap-16 w-full mt-10">
        <div className="flex flex-col-reverse md:flex-row gap-8 md:justify-around">
          <div className="flex flex-col gap-4 md:gap-8 w-full md:w-1/2">
            <span className="p-8 rounded-full bg-[#E7D7FD]  w-[50px] h-[50px] font-bold flex text-2xl justify-center items-center">
              1
            </span>
            <span className="text-secondary-900 font-bold text-xl md:text-2xl">
              {useCases[0].title}
            </span>
            <span className="text-secondary-900 text-base font-medium">
              {useCases[0].description}
            </span>
          </div>
          {useCases[0].image}
        </div>
        <div className="flex flex-col md:flex-row gap-8 md:justify-around">
          {useCases[1].image}
          <div className="flex flex-col gap-4 md:gap-8 w-full md:w-1/2">
            <span className="p-8 rounded-full bg-[#E7D7FD]  w-[50px] h-[50px] font-bold flex text-xl md:text-2xl justify-center items-center">
              2
            </span>
            <span className="text-secondary-900 font-bold text-xl md:text-2xl">
              {useCases[1].title}
            </span>
            <span className="text-secondary-900 font-medium text-base">
              {useCases[1].description}
            </span>
          </div>
        </div>
        <div className="flex flex-col-reverse md:flex-row gap-8 md:justify-around">
          <div className="flex flex-col gap-4 md:gap-8 w-full md:w-1/2">
            <span className="p-8 rounded-full bg-[#E7D7FD]  w-[50px] h-[50px] font-bold flex text-xl md:text-2xl justify-center items-center">
              3
            </span>
            <span className="text-secondary-900 font-bold text-xl md:text-2xl">
              {useCases[2].title}
            </span>
            <span className="text-secondary-900 font-medium text-base">
              {useCases[2].description}
            </span>
          </div>
          {useCases[2].image}
        </div>
      </div>
    </section>
  );
}
